/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/capital_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="30" cy="30" r="2"/><circle pid="1" cx="2" cy="30" r="2"/><circle pid="2" cx="30" cy="2" r="2"/><circle pid="3" cx="2" cy="2" r="2"/><path pid="4" d="M16 2L4 9v14l12 7 12-7V9L16 2zm-2 12V6h1v8h2V6h1v16h-4v-8zm4 12h-4v-1h4v1zm3-4v-9h-1v11h-8V13h-1v9H7l5-12v3h1v10h6V13h1v-3l5 12h-4z"/><g><path pid="5" d="M16 32.076L2 24.037V7.965L16-.076l14 8.041v16.072l-14 8.039zM3 23.459l13 7.465 13-7.465V8.543L16 1.076 3 8.543v14.916z"/></g>'
  }
})
